import React from 'react';
import WalterPyneWebsite from './WalterPyneWebsite';

function App() {
  return (
    <WalterPyneWebsite />
  );
}

export default App;